export default __webpack_public_path__ + "static/line-presentation-a2b9d8eb5ca952ff7a034e8a33c093b2.png";